/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddServiceDefinition200Response
 */
export interface AddServiceDefinition200Response {
    /**
     * 
     * @type {string}
     * @memberof AddServiceDefinition200Response
     */
    uuid?: string;
}

/**
 * Check if a given object implements the AddServiceDefinition200Response interface.
 */
export function instanceOfAddServiceDefinition200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AddServiceDefinition200ResponseFromJSON(json: any): AddServiceDefinition200Response {
    return AddServiceDefinition200ResponseFromJSONTyped(json, false);
}

export function AddServiceDefinition200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddServiceDefinition200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'uuid': !exists(json, 'uuid') ? undefined : json['uuid'],
    };
}

export function AddServiceDefinition200ResponseToJSON(value?: AddServiceDefinition200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'uuid': value.uuid,
    };
}

